import { useInfiniteQuery } from '@tanstack/react-query';

import * as ApiWiki from '@Api/Wiki';
import useSearchParams from '@Hooks/useSearchParams';
import { useRequest } from '@Contexts/Request';

import type { Response } from '@Api/Wiki/getWikiArticles';

export interface Params {
  categoryId?: string | number;
  tagId?: string | number;
}

function useInfiniteWikiArticles(params?: Params) {
  const { categoryId, tagId } = params || {};
  const { queryClient } = useRequest();
  const searchParams = useSearchParams();
  const initialPage = +searchParams.get('page') || 1;
  const keys = ['infiniteWikiArticles', categoryId, tagId].filter(Boolean);
  const category = useInfiniteQuery({
    queryKey: keys,
    queryFn: ({ pageParam }) => {
      const cache = queryClient.getQueryData<Record<string, Response[]>>(keys);

      if (cache && !pageParam) return Promise.resolve(cache?.pages[0]);

      return ApiWiki.getWikiArticles({ page: pageParam || initialPage, categoryId, tagId });
    },
    initialPageParam: 0,
    enabled: true,
    placeholderData: (previousData) => previousData,
    // TODO:backend бэкенд не возвращает номер страницы, из-за чего пагинация работает некорректно
    getNextPageParam: (lastPage) => {
      return lastPage.countLeft ? lastPage.page + 1 : null;
    },
  });

  return category;
}

export default useInfiniteWikiArticles;
